import { categories } from "@/data/categories";

/** Top manufacturers shown in the header mega menu (mapped to /manufacturers/{slug}). */
const FEATURED_MANUFACTURER_SLUGS = [
  "allen-bradley",
  "siemens",
  "abb",
  "schneider-electric",
  "mitsubishi",
  "fanuc",
  "omron",
  "beckhoff",
  "lenze",
  "rexroth",
  "b-r",
  "delta",
];

const MANUFACTURER_DISPLAY_NAMES: Record<string, string> = {
  "allen-bradley": "Allen-Bradley",
  siemens: "Siemens",
  abb: "ABB",
  "schneider-electric": "Schneider Electric",
  mitsubishi: "Mitsubishi Electric",
  fanuc: "FANUC",
  omron: "Omron",
  beckhoff: "Beckhoff",
  lenze: "Lenze",
  rexroth: "Bosch Rexroth",
  "b-r": "B&R Automation",
  delta: "Delta Electronics",
};

export const categoriesMegaColumns = () => {
  // Split categories into 3 balanced columns for the mega menu grid.
  const chunkSize = Math.ceil(categories.length / 3);
  return [0, 1, 2].map((i) => ({
    heading:
      i === 0 ? "Control & PLC" : i === 1 ? "Drives & Motion" : "Power & Components",
    items: categories
      .slice(i * chunkSize, (i + 1) * chunkSize)
      .map((c) => ({ label: c.shortName, to: `/category/${c.slug}` })),
  }));
};

export const manufacturersMegaColumns = () => {
  const items = FEATURED_MANUFACTURER_SLUGS.map((slug) => ({
    label: MANUFACTURER_DISPLAY_NAMES[slug] ?? slug,
    to: `/manufacturers/${slug}`,
  }));
  const per = Math.ceil(items.length / 3);
  return [0, 1, 2].map((i) => ({
    heading: i === 0 ? "Top Brands" : i === 1 ? "Motion & Servo" : "Global OEMs",
    items: items.slice(i * per, (i + 1) * per),
  }));
};